import React from "react";
import { Col, Row } from "antd";

const FollowingTeamsTab = ({ itsMe }) => {

    return (
        <div className="following-tab" >
            <Row type="flex" gutter={0} justify="center">
                <Col xs={24} md={18} xl={14}>
                    <div className="following-tabs-message">
                        <p>{ itsMe ? 'You' : 'User' } not Following Teams</p>
                        <div className="in-development">Feature in development</div>
                    </div>
                </Col>
            </Row>
        </div>
    );

};

export default FollowingTeamsTab;